// extracted by mini-css-extract-plugin
export var cardHeader = "_rl-0";
export var reorderHandle = "_rl-3";
export var titleArea = "_rl-1";
export var titleAreaWithHandle = "_rl-2";